import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ComponentsModule } from '@app/components/components.module';
import { EaLoanModule } from '@app/components/ea-loan/ea-loan.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EaActifEnDirectFormComponent } from './assets/ea-actif-en-direct-form/ea-actif-en-direct-form.component';
import { EaAssetsFormComponent } from './assets/ea-assets-form/ea-assets-form.component';
import { EaAssurancePrevoyanceFormComponent } from './assets/ea-assurance-prevoyance-form/ea-assurance-prevoyance-form.component';
import { EaPrevoyanceContratFormComponent } from './prevoyance/ea-prevoyance-contrat-form/ea-prevoyance-contrat-form.component';
import { EaAutresFormComponent } from './assets/ea-autres-form/ea-autres-form.component';
import { EaAvFormComponent } from './assets/ea-av-form/ea-av-form.component';
import { EaBankResourcesFormComponent } from './assets/ea-bank-resources-form/ea-bank-resources-form.component';
import { EaCompteCryptoFormComponent } from './assets/ea-compte-crypto-form/ea-compte-crypto-form.component';
import { EaCompteTitresFormComponent } from './assets/ea-compte-titres-form/ea-compte-titres-form.component';
import { EaContratCapiFormComponent } from './assets/ea-contrat-capi-form/ea-contrat-capi-form.component';
import { EaCrowdfundingFormComponent } from './assets/ea-crowdfunding-form/ea-crowdfunding-form.component';
import { EaDefiscFormComponent } from './assets/ea-defisc-form/ea-defisc-form.component';
import { EaPeaFormComponent } from './assets/ea-pea-form/ea-pea-form.component';
import { EaPeaPmeFormComponent } from './assets/ea-pea-pme-form/ea-pea-pme-form.component';
import { EaPeeFormComponent } from './assets/ea-pee-form/ea-pee-form.component';
import { EaPeiFormComponent } from './assets/ea-pei-form/ea-pei-form.component';
import { EaPerFormComponent } from './assets/ea-per-form/ea-per-form.component';
import { EaPercoFormComponent } from './assets/ea-perco-form/ea-perco-form.component';
import { EaPerpFormComponent } from './assets/ea-perp-form/ea-perp-form.component';
import { EaPmeFormComponent } from './assets/ea-pme-form/ea-pme-form.component';
import { EaPrefonFormComponent } from './assets/ea-prefon-form/ea-prefon-form.component';
import { EaRenonciationFormComponent } from './assets/ea-renonciation-form/ea-renonciation-form.component';
import { EaTangibleFormComponent } from './assets/ea-tangible-form/ea-tangible-form.component';
import { EaBudgetFormComponent } from './budget/ea-budget-form/ea-budget-form.component';
import { EaChooseFormComponent } from './career/ea-choose-form/ea-choose-form.component';
import { EaEarningFormComponent } from './career/ea-earning-form/ea-earning-form.component';
import { EaObjectiveFormComponent } from './career/ea-objective-form/ea-objective-form.component';
import { EaProfessionFormComponent } from './career/ea-profession-form/ea-profession-form.component';
import { EaDocumentFormComponent } from './documents/ea-document-form/ea-document-form.component';
import { EaJustifsFormComponent } from './documents/ea-justifs-form/ea-justifs-form.component';
import { EstatesFormsModule } from './estates/estates.module';
import { EaLoanCapacityFormComponent } from './loans/ea-loan-capacity-form/ea-loan-capacity-form.component';
import { EaLoanFormComponent } from './loans/ea-loan-form/ea-loan-form.component';
import { EaOptimizationBuyOrRentFormComponent } from './optimization/ea-optimization-buy-or-rent-form/ea-optimization-buy-or-rent-form.component';
import { EaOptimizationFiscalityRentFormComponent } from './optimization/ea-optimization-fiscality-rent-form/ea-optimization-fiscality-rent-form.component';
import { EaProfilEmprunteurComponent } from './optimization/ea-profil-emprunteur/ea-profil-emprunteur.component';
import { EaParrainageFormComponent } from './parrainages/ea-parrainage-form/ea-parrainage-form.component';
import { EaChildFormComponent } from './profile/ea-child-form/ea-child-form.component';
import { EaCompanyFormComponent } from './profile/ea-company-form/ea-company-form.component';
import { EaHouseFormComponent } from './profile/ea-house-form/ea-house-form.component';
import { EaProfileFormComponent } from './profile/ea-profile-form/ea-profile-form.component';
import { EaRiskProfileFormComponent } from './profile/ea-risk-profile-form/ea-risk-profile-form.component';
import { EaEsgFormComponent } from './profile/ea-esg-form/ea-esg-form.component';
import { EaSimulationAvFormComponent } from './simulation/ea-simulation-av-form/ea-simulation-av-form.component';
import { EaSimulationAvPackFormComponent } from './simulation/ea-simulation-av-pack-form/ea-simulation-av-pack-form.component';
import { EaSimulationBottomSheetComponent } from './simulation/ea-simulation-bottom-sheet/ea-simulation-bottom-sheet.component';
import { EaSimulationFcpiFormComponent } from './simulation/ea-simulation-fcpi-form/ea-simulation-fcpi-form.component';
import { EaSimulationFiscalityRentFormComponent } from './simulation/ea-simulation-fiscality-rent-form/ea-simulation-fiscality-rent-form.component';
import { EaSimulationLmnpFormComponent } from './simulation/ea-simulation-lmnp-form/ea-simulation-lmnp-form.component';
import { EaSimulationLoanFormComponent } from './simulation/ea-simulation-loan-form/ea-simulation-loan-form.component';
import { EaSimulationPerFormComponent } from './simulation/ea-simulation-per-form/ea-simulation-per-form.component';
import { EaSimulationPerPackFormComponent } from './simulation/ea-simulation-per-pack-form/ea-simulation-per-pack-form.component';
import { EaSimulationPinelFormComponent } from './simulation/ea-simulation-pinel-form/ea-simulation-pinel-form.component';
import { EaSimulationScpiFormComponent } from './simulation/ea-simulation-scpi-form/ea-simulation-scpi-form.component';
import { EaSimulationScpiPackFormComponent } from './simulation/ea-simulation-scpi-pack-form/ea-simulation-scpi-pack-form.component';
import { EaSimulationSoficaFormComponent } from './simulation/ea-simulation-sofica-form/ea-simulation-sofica-form.component';
import { SubscriptionModule } from './subscription/subscription.module';
import { EaDeductionFormComponent } from './taxes/ea-deduction-form/ea-deduction-form.component';
import { EaReductionFormComponent } from './taxes/ea-reduction-form/ea-reduction-form.component';

const COMPONENTS = [
  EaEarningFormComponent,
  EaObjectiveFormComponent,
  EaProfessionFormComponent,
  EaAssetsFormComponent,
  EaDefiscFormComponent,
  EaBankResourcesFormComponent,
  EaTangibleFormComponent,
  EaPerFormComponent,
  EaCrowdfundingFormComponent,
  EaAvFormComponent,
  EaPmeFormComponent,
  EaProfileFormComponent,
  EaHouseFormComponent,
  EaChildFormComponent,
  EaCompanyFormComponent,
  EaLoanFormComponent,
  EaLoanCapacityFormComponent,
  EaProfilEmprunteurComponent,
  EaSimulationPinelFormComponent,
  EaSimulationLmnpFormComponent,
  EaSimulationScpiFormComponent,
  EaSimulationScpiPackFormComponent,
  EaParrainageFormComponent,
  EaSimulationFcpiFormComponent,
  EaSimulationSoficaFormComponent,
  EaParrainageFormComponent,
  EaSimulationAvFormComponent,
  EaSimulationAvPackFormComponent,
  EaSimulationLoanFormComponent,
  EaOptimizationBuyOrRentFormComponent,
  EaOptimizationFiscalityRentFormComponent,
  EaSimulationFiscalityRentFormComponent,
  EaSimulationPerFormComponent,
  EaSimulationPerPackFormComponent,
  EaDocumentFormComponent,
  EaDeductionFormComponent,
  EaReductionFormComponent,
  EaBudgetFormComponent,
  EaRenonciationFormComponent,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    EaPerpFormComponent,
    EaCompteTitresFormComponent,
    EaCompteCryptoFormComponent,
    EaPeaFormComponent,
    EaPeeFormComponent,
    EaPrefonFormComponent,
    EaPercoFormComponent,
    EaPeaPmeFormComponent,
    EaSimulationBottomSheetComponent,
    EaChooseFormComponent,
    EaContratCapiFormComponent,
    EaJustifsFormComponent,
    EaPeiFormComponent,
    EaActifEnDirectFormComponent,
    EaAutresFormComponent,
    EaAssurancePrevoyanceFormComponent,
    EaRiskProfileFormComponent,
    EaEsgFormComponent,
    EaPrevoyanceContratFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    EaLoanModule,
    MatSelectModule,
    MatButtonModule,
    TranslateModule,
    NgxMaskDirective,
    NgxMaskPipe,
    EstatesFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatCardModule,
    MatTabsModule,
    MatListModule,
    SubscriptionModule,
  ],
  exports: [
    EstatesFormsModule,
    SubscriptionModule,
    ...COMPONENTS,
    EaRiskProfileFormComponent,
    EaEsgFormComponent,
  ],
  providers: [provideNgxMask()],
})
export class EaFormsModule {}
